import {defineAsyncComponent} from "vue";

const partials = {
	'block': defineAsyncComponent({
		loader: () => import(/* webpackChunkName: "block" *//* webpackPreload: true */'@core/vuejs/templates/components/commons/Block'),
		loadingComponent: 'preload'
	}),
}

/**
 *
 * @param app
 */
export const registerSectionComponents = function (app)
{
	let components = Object.assign(partials);
	for (const component in components) {
		if (!app._context.components.hasOwnProperty(component))
			app.component(component, components[component])
	}
}